import { Injectable } from '@angular/core';
import { Yii } from 'libraries/interfaces/Yii';
import { get } from 'scriptjs';
import { IGoogleMaps } from './IGoogleMaps';

declare const window: any;
declare const google: any;

@Injectable()
export class GoogleMapApiLoaderService {
    public async load(apiKey: string): Promise<IGoogleMaps> {
        if (window.GoogleMapApiLoaderServiceImportedKey && apiKey !== window.GoogleMapApiLoaderServiceImportedKey) {
            throw new Error(Yii.t("wui-shared-js", "La librairie google maps a déjà été chargée avec une autre clé d'API"));
        }

        window.GoogleMapApiLoaderServiceImportedKey = apiKey;

        if (!window.GoogleMapApiLoaderServicePromise) {
            window.GoogleMapApiLoaderServicePromise = new Promise((resolve) => {
                get(`https://maps.googleapis.com/maps/api/js?key=${apiKey}&libraries=places`, () => {
                    resolve({
                        ...google.maps
                    });
                });
            });
        }

        return window.window.GoogleMapApiLoaderServicePromise;
    }
}